import { memo } from "react";
import { IconProps, iconSize } from "./types";

const LogoIcon = (props: IconProps) => (
  <svg
    {...iconSize(props, 166, 200)}
    className={props.className}
    viewBox="0 0 166 200"
    fill="foreground"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M133.092 65.3457C139.623 57.5511 151.644 56.0288 159.428 62.5693C167.211 69.11 168.227 80.7316 161.695 88.5264C148.115 105.332 129.234 117.721 107.593 123.136V175.408C107.593 188.99 96.5819 200.001 83 200.001C69.418 200.001 58.4074 188.99 58.4072 175.408V123.136C36.7662 117.721 17.885 105.332 4.30466 88.5264C-2.22656 80.7317 -1.21123 69.11 6.57224 62.5693C14.3559 56.0288 26.3767 57.5512 32.9082 65.3457C44.7431 79.9916 62.7796 89.3054 83 89.3057C103.22 89.3055 121.257 79.9916 133.092 65.3457Z"
      fill={props.fill}
    />
    <path
      d="M83 0C98.2798 0 110.667 12.3983 110.667 27.6924C110.667 42.9865 98.2798 55.3848 83 55.3848C67.7202 55.3846 55.334 42.9864 55.334 27.6924C55.334 12.3984 67.7202 0.000166124 83 0Z"
      fill={props.fill}
    />
  </svg>
);

export default memo(LogoIcon);
